/**
 * Hint bajo «Editar política». El UUID interno no se expone en edición.
 */
export function retentionEditRecordIdHint(id: string | null | undefined): string | null {
  void id;
  return null;
}

export function shouldShowRetentionEditRecordId(id: string | null | undefined): boolean {
  return retentionEditRecordIdHint(id) != null;
}
